// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__e0ae6590dd93c761ec58","cls2":"CreateSocialItem-cls2__bbb31e4f5186b07a6f29 CreateSocialItem-cls1__e0ae6590dd93c761ec58"};